/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Canonical content-entity discriminator.
 * @export
 */
export const ContentType = {
    ACTIVATION: 'ACTIVATION',
    COMPETITION: 'COMPETITION',
    MISSION_PLAN: 'MISSION_PLAN',
    QUEST_CONFIG: 'QUEST_CONFIG',
    SURFACE: 'SURFACE',
    GAMIFICATION: 'GAMIFICATION',
    ADJUSTMENT: 'ADJUSTMENT'
} as const;
export type ContentType = typeof ContentType[keyof typeof ContentType];


export function instanceOfContentType(value: any): boolean {
    for (const key in ContentType) {
        if (Object.prototype.hasOwnProperty.call(ContentType, key)) {
            if (ContentType[key as keyof typeof ContentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ContentTypeFromJSON(json: any): ContentType {
    return ContentTypeFromJSONTyped(json, false);
}

export function ContentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentType {
    return json as ContentType;
}

export function ContentTypeToJSON(value?: ContentType | null): any {
    return value as any;
}

export function ContentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ContentType {
    return value as ContentType;
}

